var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {if (value) {
if (value.AggregateName) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = value.AggregateName) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"account-name-column-template\"\u003E";
if (value.link) {
if (value.isForVNext) {
if (value.aid !== 0) {
pug_html = pug_html + "\u003Ca" + (" class=\"account-name scope-navigator text-overflow-ellipsis\""+pug.attr("aria-label", value.ariaLabel, true, true)+pug.attr("href", value.link, true, true)+pug.attr("title", value.AccountName, true, true)+" data-preventdefaultnavigation"+pug.attr("data-aid", value.aid, true, true)+pug.attr("data-cid", value.cid, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = value.AccountName) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"account-name customer-scope-navigator text-overflow-ellipsis\""+pug.attr("aria-label", value.ariaLabel, true, true)+pug.attr("href", value.link, true, true)+pug.attr("title", value.AccountName, true, true)+pug.attr("data-cid", value.cid, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = value.AccountName) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"account-name\""+pug.attr("href", value.link, true, true)+pug.attr("title", value.AccountName, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = value.AccountName) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan class=\"account-name\"\u003E" + (pug.escape(null == (pug_interp = value.AccountName) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (value.inactiveLabel) {
pug_html = pug_html + "\u003Cdiv class=\"account-inactive-label\"\u003E" + (pug.escape(null == (pug_interp = value.inactiveLabel) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"account-number\"\u003E(" + (pug.escape(null == (pug_interp = value.AccountNumber) ? "" : pug_interp)) + ")\u003C\u002Fdiv\u003E";
if (value.hasVNextDropdown) {
pug_html = pug_html + "\u003Cspan class=\"account-navigation clickable\" tabindex=\"0\" role=\"button\"\u003E\u003Cspan class=\"iconba iconba-More\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;